<footer>
    2024 &copy; #1od5miliona
</footer>
